import React from "react";
import { bonuses } from "../../data/content";
export function Bonuses() {
  return <section className="bg-forest py-16 text-ivory md:py-24" data-id="element-14" data-mp="1hkiz4m3p05wu">
      <div className="mx-auto max-w-wrap px-5 md:px-8" data-id="element-15" data-mp="1hi68zlns6p8p">
        <h2 className="heading text-center text-[42px] md:text-[64px]" data-id="element-16" data-mp="1ckef4m3kst1v">
          Five <span className="text-sand" data-id="element-17" data-mp="18juidjmwzrg9">complementary bonuses</span>
        </h2>
        <p className="mx-auto mt-4 max-w-[600px] text-center text-[17px] text-ivory/85" data-id="element-18" data-mp="18hrlqgr9b02k">
          For everything around the bags you make — from choosing fabrics to packaging the finished piece.
        </p>
        <div className="mt-10 grid gap-5 md:mt-14 md:grid-cols-2 lg:grid-cols-6 lg:[&>*:nth-child(4)]:col-start-2" data-id="element-19" data-mp="1w95dakhl2rmh">
          {bonuses.map((b, i) => <article key={b.title} className="flex flex-col overflow-hidden rounded-2xl bg-cream text-charcoal lg:col-span-2" data-id="element-20" data-mp="1r9kf4ca8mnat" data-mpi={i}>
              <img src={b.image} alt={`${b.title} cover`} className="aspect-square w-full object-cover" loading="lazy" data-id="element-21" data-mp="krni49e2j0bk" />
              <div className="flex flex-1 flex-col p-6" data-id="element-22" data-mp="1etwrv550i6ft">
                <span className="w-fit rounded-full bg-sand-light px-3 py-1 text-[11px] font-bold uppercase tracking-[0.14em] text-forest" data-id="element-23" data-mp="1eug9slunwutu">
                  Bonus {String(i + 1).padStart(2, "0")} · Included
                </span>
                <h3 className="mt-3 font-display text-[26px] font-bold uppercase leading-[1.05] text-forest" data-id="element-24" data-mp="1as1rq3ythz3m">{b.title}</h3>
                <p className="mb-0 mt-3 text-[15px] leading-relaxed text-muted" data-id="element-25" data-mp="w2ngeqbol7ll">{b.body}</p>
              </div>
            </article>)}
        </div>
      </div>
    </section>;
}